'use client';

import { useRouter } from 'next/navigation';

import type { ErrorContentType } from './ErrorContent';
import ErrorContent from './ErrorContent';

type Props = {
  title: string;
  description: string;
  showHomeButton?: boolean;
  type?: ErrorContentType;
};

function PageError(props: Props) {
  const { title, description, showHomeButton = true, type = 'generic' } = props;
  const router = useRouter();

  const handleHomeClick = () => {
    router.push('/');
  };

  return (
    <div className="grid min-h-[60vh] place-items-center px-4">
      <ErrorContent
        title={title}
        description={description}
        showHomeButton={showHomeButton}
        type={type}
        onHomeClick={handleHomeClick}
      />
    </div>
  );
}

export default PageError;
